import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LandingPage from "./LandingPage";
import MessageBoard from "./message-board/MessageBoard";
import AuthPage from "./pages/AuthPage";
import OlipopRankingPage from "./pages/OlipopRankingPage";
import StampBrowsePage from "./pages/StampBrowsePage";
import StampDetailPage from "./pages/StampDetailPage";
import ProfilePage from "./pages/ProfilePage";
import TodoListPage from "./pages/TodoListPage";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<AuthPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <LandingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <MessageBoard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/olipop"
            element={
              <ProtectedRoute>
                <OlipopRankingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/todo"
            element={
              <ProtectedRoute>
                <TodoListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stamps"
            element={
              <ProtectedRoute>
                <StampBrowsePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stamps/:slug"
            element={
              <ProtectedRoute>
                <StampDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
